import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c(VChip,{key:item.id,class:_vm.chipClass,attrs:{"color":item.color}},[_c('span',{style:({ color: _vm.determineTextColor(item.color) })},[_vm._t("default",null,{"item":item})],2)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }